
<template>
  <div class="scratch-container" :class="device.isMobile ? 'scratch-container-mobile' : ''">
    <div class="reset" @click.stop="reset"></div>
    <div
      class="action-content"
    >
      <scratchAction
        ref="scratch"
        maskColor="#CCD7E1"
        fillStyle="#333333"
        font="30rem 微软雅黑"
        text="刮一刮"
        :radius="5"
        :scratchRadius="20"
        :scratchPercent="60"
        @scratchStart="scratchStart"
        @scratchEnd="scratchEnd"
        @scratchAll="scratchAll"
      >
        <!-- 自定义奖品内容插槽 -->
        <div class="prize">
          <div class="prize-text">数字教材是依据课程教学要求，能够系统反映学科专业内容，针对不同教学对象，利用数字技术加工制作，能够独立打包封装的用于教学的出版物。</div>
        </div>
      </scratchAction>
    </div>
  </div>
</template>
<script>

/*
交互动作组件 -- 刮一刮
*/
import scratchAction from "./scratchAction.vue";
export default {
  name: "dynamicImage",
  components: {
    scratchAction
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      handleData: [],
    }
  },
  mounted() {
    this.handleData = this.content.content;
  },
  methods: {
    scratchStart() {
      console.log("scratchStart");
    },
    scratchEnd() {
      console.log("scratchEnd");
    },
    scratchAll() {
      console.log("scratchAll");
    },
    reset() {
      this.$refs.scratch.reset();
    },
  },
}
</script>


<style lang="scss" scoped>
.scratch-container{

  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: 6rem;
    right: 0rem;
    cursor: pointer;
  }

  .action-content{
    width: 100%;
    height: 120rem;
    margin: 20rem auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .prize{
      width: 100%;
      height: 120rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255,255,255,0.7);
      border-radius: 10rem;

      .prize-text{
        font-size: 18rem;
        color: #333;
        line-height: 28rem;
        text-indent: 2em;
        padding: 0 22rem;
      }
    }
  }
}
.scratch-container-mobile{
  
  .reset{
    width: 44rem;
    height: 44rem;
    top: 0;
  }
}
</style>
